var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureAuth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_604_2694)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 17,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "url(#paint0_linear_604_2694)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 16.5,
    width: 65,
    height: 65,
    rx: 13.3,
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9397 43.6003C59.0979 43.9043 60.0446 44.8505 60.3493 46.0085C60.7581 47.6179 60.0445 49.1003 58.8202 49.8582L58.5833 50.0048V50.2833V53.5833C58.5833 54.4572 57.8739 55.1667 57 55.1667C56.1261 55.1667 55.4167 54.4572 55.4167 53.5833V50.2833V50.0045L55.1794 49.8579C54.1873 49.2451 53.5333 48.1527 53.5333 46.9167C53.5333 44.707 55.6268 42.9854 57.9382 43.5999L57.9397 43.6003Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2112 44.2696L72.2107 44.2682C70.129 37.5756 64.0187 33.0833 57.0166 33.0833C48.2405 33.0833 41.1 40.2239 41.1 49C41.1 57.7761 48.2405 64.9167 57.0166 64.9167C64.001 64.9167 70.1117 60.4422 72.1939 53.7825L72.1939 53.7825L72.1956 53.777C72.3112 53.3915 72.7205 53.1698 73.1396 53.2956C73.5239 53.4108 73.7451 53.8341 73.6225 54.235C71.3208 61.5257 64.6478 66.4167 57 66.4167C47.3928 66.4167 39.5833 58.6072 39.5833 49C39.5833 39.3928 47.3928 31.5833 57 31.5833C64.6798 31.5833 71.3526 36.5061 73.6384 43.8127C73.7603 44.2232 73.5319 44.6379 73.1545 44.755C72.7432 44.8773 72.3277 44.6482 72.2112 44.2696Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_604_2694",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_2694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_2694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_2694",
    x1: 25,
    y1: 17,
    x2: 89,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureAuth);
export default __webpack_public_path__ + "static/media/SecureAuth.5411a424d11c2529fc76889243ac2827.svg";
export { ForwardRef as ReactComponent };